import React, { useState } from 'react';
import CalendarAbsenceEventForm, {
	CalendarAbsenceEventDefaultValues,
	CalendarAbsenceEventFormValues,
} from './CalendarAbsenceEventForm';
import {
	CreateWorkplaceMemberAbsenceInput,
	useCreateWorkplaceMemberAbsenceMutation,
} from '../../../../graphql/graphql';
import useApiClient from '../../../Base/Hooks/useApiClient';
import Loading from '../../../../Components/Loading';
import { prepareAbsenceDateRange } from '../../Helpers/absenceDateRange.helper';

interface Props {
	isEdit?: boolean;
	onUpdate: (values: CalendarAbsenceEventFormValues) => void;
	onRemove: () => void;
	defaultValues?: CalendarAbsenceEventDefaultValues;
	onCreate: () => void;
}

const CalendarWorkplaceMemberAbsenceEvent: React.FC<Props> = ({
	onCreate,
	onUpdate,
	onRemove,
	isEdit,
	defaultValues,
}) => {
	const { displayError, displayGQLError } = useApiClient();
	const [isLoading, setIsLoading] = useState(false);
	const [createAbsence] = useCreateWorkplaceMemberAbsenceMutation();

	const handleCreate = async (values: CalendarAbsenceEventFormValues) => {
		setIsLoading(true);
		const { start, end } = prepareAbsenceDateRange(values);
		const { reason, allowContactInAbsence, workplaces } = values;

		if (workplaces) {
			try {
				const input: CreateWorkplaceMemberAbsenceInput = {
					workplaceMemberIds: workplaces.map(w => w.value as string),
					start,
					end,
					description: reason,
					allowContactInAbsence,
				};

				const response = await createAbsence({ input });

				displayGQLError(response);
				if ('data' in response) {
					onCreate();
				}
			} catch (e) {
				displayError(e);
			}
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<CalendarAbsenceEventForm
			onSubmit={isEdit ? onUpdate : handleCreate}
			onRemove={onRemove}
			defaultValues={defaultValues}
			isEdit={isEdit}
		/>
	);
};

export default CalendarWorkplaceMemberAbsenceEvent;
